import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  fileName: string;
  projectName: string;
  owner: string

  constructor(protected ref: NbDialogRef<InfoComponent>) { }

  ngOnInit(): void {
  }

  cancel() {
    this.ref.close({ });
  }

}
